import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/vision_mission.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }

import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sub4',
  setup(__props) {

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("비전과 미션"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("figure", null, [
          _createVNode(_component_n_space, { justify: "center" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                style: {"width":"800px"},
                alt: "비전"
              }, null, -1)
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})